import { EmptyPlaylist } from '@/constant/imgImport';
import { Skeleton } from '@mui/material';
import Divider from 'design-system/components/Divider/Divider';
import { twMerge } from 'tailwind-merge';
import { TDoccenLibraryPlaylist } from './types';

const PlaylistSkeleton = ({
  ...props
}: Omit<TDoccenLibraryPlaylist, 'data'>) => {
  return (
    <div
      {...props}
      className={twMerge(
        'space-y-2 rounded-[8px] border border-border_disabled transition-all ease-linear',
        props.disabled
          ? 'bg-Action/DisabledBackground'
          : 'cursor-pointer bg-Other/White hover:bg-Action/Hover focus:border-Primary/Main active:border-Primary/Main active:bg-Action/DC/Selected',
        props.className
      )}
    >
      <div className="rounded-[7px]">
        <img
          src={EmptyPlaylist}
          alt="collection thumbnail"
          className="aspect-[1.75] w-full rounded-lg"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className="space-y-[4px] px-2 pb-2">
        <Skeleton variant="rounded" width={'100%'} height={'16px'} />
        <Skeleton variant="rounded" width={'100%'} height={'38px'} />
        <Skeleton variant="rounded" width={'100%'} height={'16px'} />
        <Divider />
        <Skeleton variant="rounded" width={'100%'} height={'23px'} />
      </div>
    </div>
  );
};

export default PlaylistSkeleton;
